/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/




  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

/*
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });
*/
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      insuranceCalc();
    }
  });
  function insuranceSet(){
  var attributes = {};
  if(!document.querySelector('[name="attributes[insurance]"]').checked){
                //customer has declined insurance
                attributes = {
                    "insurance": "false",
                    "decline-insurance": "declined"
                    }
            }
  else{
    //customer has accepted insurance
                attributes = {
                    "insurance": "true",
                    "decline-insurance": "not-declined"
                    }
  }
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ attributes: attributes })
                    })
                    .then(response => {
                      this.insuranceCalc();
                    })
                    .catch((error) => {
                    console.error('Error:', error);
                    });
}
function insuranceCalc(){
  fetch(window.Shopify.routes.root + 'products/package-protection.js')
  .then(response => response.json())
  .then(insurProduct => {
        var reCalc = false;
        var insurVar = 0;
        var reqVar = 0;
        var reqPrice = 0;
        var insurTotal = 0;
        var exemptInCart = 0;
        var insurPercent = 0.0275;
        var aItem;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
            for(aItem of cart.items){
                if(aItem.handle == "package-protection"){
                    insurTotal = aItem.original_line_price;
                    insurVar = aItem.variant_id;
                    reqVar = aItem.variant_id;
                    reqPrice = aItem.original_price;
                }
                else if(aItem.gift_card){
                    exemptInCart = exemptInCart + aItem.original_line_price;
                }
            }
            var calcTotal = Math.round((cart.total_price - exemptInCart - insurTotal)*insurPercent);
            var attributes = {};
            var updates = {};
            if(calcTotal == 0){
                //no cart contents require insurance, hide the div entirely
                attributes = {
                    "insurance": "false",
                    "decline-insurance": "not-declined"
                    }
            }
                          var v;
                for(v of insurProduct.variants){
                    if(v.price < calcTotal){
                    //do nothing, need to keep going to a higher variant
                    }
                    else{
                        if(insurVar != v.id){
                            reCalc = true;
                            reqVar = v.id;
                            reqPrice = v.price;
                        }
                        break;
                    }
                }
            try{
            document.getElementById("reqPrice").innerHTML = Shopify.formatMoney(reqPrice, window.Shopify.money_format);
            }
            catch(error){}
            let pChecked = false;
            try{
             pChecked = document.querySelector('[name="attributes[insurance]"]').checked
            }
            catch(error){
                calcTotal = 0;
            }
            if(!pChecked){
                //customer has declined insurance
                calcTotal = 0;
            }
            if(calcTotal == 0 && insurTotal > 0){
                //then there is insurance in the cart that shouldn't be, remove it
                updates = {};
                updates[insurVar] = 0;
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates: updates, attributes: attributes })
                    })
                    .then(response => {
                    document.dispatchEvent(new CustomEvent("theme:cart:reload"));
                    })
                    .catch((error) => {
                    console.error('Error:', error);
                    });
            }
            else if(calcTotal > 0)
            {
                //then the cart is eligible for insurance, check to see if right amount is applied
                if(reCalc){
                    //then current insurance amount in cart is not correct
                    updates = {};
                    updates[reqVar] = 1;
                    
                    if(insurVar != 0)
                    {
                        //insurance is currently in the cart, but not the correct amount, remove old
                        updates[insurVar] = 0;
                    }
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ updates: updates, attributes: attributes  })
                    })
                    .then(response => {
                        document.dispatchEvent(new CustomEvent("theme:cart:reload"));
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                }
            }
        })
    });
}
  /*
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  */
